import LifecareStudioNumberInput from './LifecareStudioNumberInput';
import {
  ageYearCellClasses,
  ageYearInputClasses,
  ageYearInputsRowClasses,
  ageYearSubRowClasses,
  ageYearSubRowLabelClasses,
  ageYearToggleClasses,
} from './lifecareStudioClasses';
import { LIFE_EXPECTANCY_LABEL } from '../../utils/lifecarePlanUtils';

const AGE_YEAR_SUB_ROWS = [
  { label: 'Beginning', ageField: 'beginningAge', yearField: 'beginningYear' },
  { label: 'Ending', ageField: 'endingAge', yearField: 'endingYear' },
];

const LifecareStudioAgeYearCell = ({ row, onFieldChange }) => (
  <div className={ageYearCellClasses}>
    {AGE_YEAR_SUB_ROWS.map(({ label, ageField, yearField }) => (
      <div key={label} className={ageYearSubRowClasses}>
        <span className={ageYearSubRowLabelClasses}>{label}</span>
        <div className={ageYearInputsRowClasses}>
          <LifecareStudioNumberInput
            value={row?.[ageField]}
            ariaLabel={`${label} age`}
            className={ageYearInputClasses}
            onValueChange={(value) => onFieldChange({ field: ageField, value })}
          />
          <LifecareStudioNumberInput
            value={row?.[yearField]}
            ariaLabel={`${label} year`}
            className={ageYearInputClasses}
            onValueChange={(value) => onFieldChange({ field: yearField, value })}
          />
        </div>
      </div>
    ))}
    <label className={ageYearToggleClasses}>
      <input
        type="checkbox"
        checked={Boolean(row?.isEndingLifeExpectancy)}
        onChange={(event) =>
          onFieldChange({ field: 'isEndingLifeExpectancy', value: event.target.checked })
        }
      />
      <span>Ends at {LIFE_EXPECTANCY_LABEL}</span>
    </label>
  </div>
);

export default LifecareStudioAgeYearCell;
